<template>
    <div>
        <div class="title-bar">
            <div class="volver-atras">
                <DxButton v-bind="backButtonProps()" @click="$router.back()"></DxButton>
                <h1>{{ $t('fichero_medida_detalle_view.title') }}</h1>
            </div>
        </div>

        <SignalsViewer :files="ficheros" :mostrarNombresFichero="true"></SignalsViewer>
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useIntl } from '@services/i18n';
import { DxButton } from 'devextreme-vue';
import { onMounted, ref, watch } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import { backButtonProps } from '@helpers/button-helper';
import SignalsViewer from '@/components/senyales/SignalsViewer.vue';
import { toastError } from '@/.shared/services/notification-service';

const api = useApi();
const intl = useIntl();
const route = useRoute();

const id = ref<number>();
const ficheros = ref<{ cfgFile: File, datFile: File } | null>(null);
// let ficheroMedidaDetalleModel = ref<FicheroMedidaDetalleModel>({} as FicheroMedidaDetalleModel);

onMounted(() => {
    watch(
        () => route.params.id,
        async (newId: string | string[]) => {
            id.value = parseInt(newId as string);
            // TODO RUBÉN: FUTURO: AL NO PASARLE PARAMETROS, IdFicheroMedida ES 0 PERO LA API DEVUELVE 200 EN VEZ DE 400  
            
            try {
                const ficheroMedidaCfg: File = await api.callStandardApi("ficheroMedidaDownload", { isFile: true }, id.value, true);
                const ficheroMedidaDat: File = await api.callStandardApi("ficheroMedidaDownload", { isFile: true }, id.value, false);
                ficheros.value = {
                    cfgFile: ficheroMedidaCfg,
                    datFile: ficheroMedidaDat,
                }
            } catch (error) {                
                toastError(intl.i18n.t('fichero_medida_detalle_view.mensaje_error_obtener_ficheros'));
                console.error(error);
            }
        },
        { immediate: true }
    );
});

</script>